import React, { useState, useEffect } from 'react';

export default function ModalConfig({ config, onSauvegarder, onFermer }) {
  const [url, setUrl]       = useState(config.url || '');
  const [prompt, setPrompt] = useState(config.prompt || '');
  const [nom, setNom]       = useState(config.nom || 'Assistant 3F');
  const [format, setFormat] = useState(config.format || 'base64');
  const [testMsg, setTestMsg] = useState(null); // { type: 'ok'|'err', texte }
  const [testEnCours, setTestEnCours] = useState(false);

  useEffect(() => {
    setUrl(config.url || '');
    setPrompt(config.prompt || '');
    setNom(config.nom || 'Assistant 3F');
    setFormat(config.format || 'base64');
  }, [config]);

  const handleSauvegarder = () => {
    onSauvegarder({ url: url.trim(), prompt: prompt.trim(), nom: nom.trim() || 'Assistant 3F', format });
    onFermer();
  };

  const handleTester = async () => {
    if (!url.trim()) { setTestMsg({ type: 'err', texte: '⚠ Veuillez saisir une URL.' }); return; }
    setTestEnCours(true);
    setTestMsg(null);
    try {
      const r = await fetch(url.trim(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ test: true, source: '3F-Chatbot' }),
      });
      setTestMsg(
        r.ok || r.status < 400
          ? { type: 'ok', texte: `✓ Webhook opérationnel (HTTP ${r.status})` }
          : { type: 'err', texte: `✗ Réponse inattendue : HTTP ${r.status}` }
      );
    } catch (e) {
      setTestMsg({ type: 'err', texte: `✗ Erreur : ${e.message} (vérifiez CORS dans n8n)` });
    }
    setTestEnCours(false);
  };

  return (
    <div style={styles.overlay} onClick={(e) => { if (e.target === e.currentTarget) onFermer(); }}>
      <div style={styles.sheet}>
        <div style={styles.handle} />
        <h2 style={styles.titre}>⚙️ Paramètres du chatbot</h2>

        <div style={styles.field}>
          <label style={styles.label}>URL Webhook n8n</label>
          <input style={styles.input} type="url" value={url} onChange={e => setUrl(e.target.value)} placeholder="https://votre-n8n.exemple.com/webhook/chatbot-3f-yvelines" />
          <div style={styles.hint}>L'URL du nœud Webhook de votre workflow n8n</div>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Prompt système <span style={styles.hidden}>(caché — invisible pour l'utilisateur)</span></label>
          <textarea
            style={styles.textarea}
            value={prompt}
            onChange={e => setPrompt(e.target.value)}
            placeholder="Ex : Tu es l'assistant de l'association Les Usagers de 3F Yvelines. Tu aides à rédiger des PV, courriers, convocations. Réponds toujours en français..."
          />
          <div style={styles.hint}>Envoyé dans chaque requête à n8n mais jamais affiché dans le chat</div>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Nom affiché de l'assistant</label>
          <input style={styles.input} type="text" value={nom} onChange={e => setNom(e.target.value)} />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Format pièces jointes</label>
          <select style={styles.input} value={format} onChange={e => setFormat(e.target.value)}>
            <option value="base64">Base64 JSON (recommandé)</option>
            <option value="formdata">FormData multipart</option>
          </select>
        </div>

        {testMsg && (
          <div style={{ ...styles.testRes, ...(testMsg.type === 'ok' ? styles.testOk : styles.testErr) }}>
            {testMsg.texte}
          </div>
        )}

        <div style={styles.btns}>
          <button style={styles.btnTest} onClick={handleTester} disabled={testEnCours}>
            {testEnCours ? '…' : '🔍 Tester'}
          </button>
          <button style={styles.btnCancel} onClick={onFermer}>Annuler</button>
          <button style={styles.btnSave} onClick={handleSauvegarder}>✓ Sauvegarder</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)',
    zIndex: 200, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
  },
  sheet: {
    background: '#fff', width: '100%', maxWidth: 480,
    borderRadius: '20px 20px 0 0', padding: '1.2rem 1.5rem 2rem',
    animation: 'slideUp .25s ease',
    maxHeight: '90vh', overflowY: 'auto',
  },
  handle: { width: 40, height: 4, background: '#e0e0e0', borderRadius: 2, margin: '0 auto 1.2rem' },
  titre: { fontSize: '1rem', fontWeight: 600, color: '#1a3a5c', marginBottom: '1.2rem' },
  field: { marginBottom: '.9rem' },
  label: { display: 'block', fontSize: '.72rem', fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '.35rem' },
  hidden: { color: '#bbb', fontWeight: 400, textTransform: 'none', letterSpacing: 0, fontSize: '.7rem' },
  hint: { fontSize: '.7rem', color: '#aaa', marginTop: '.25rem' },
  input: {
    width: '100%', padding: '.65rem .9rem', border: '1.5px solid #e0e0e0',
    borderRadius: 10, fontSize: '.88rem', fontFamily: 'Inter, sans-serif',
    color: '#111', outline: 'none', background: '#fafafa',
  },
  textarea: {
    width: '100%', padding: '.65rem .9rem', border: '1.5px solid #e0e0e0',
    borderRadius: 10, fontSize: '.84rem', fontFamily: 'Inter, sans-serif',
    color: '#111', outline: 'none', background: '#fafafa',
    resize: 'vertical', minHeight: 90,
  },
  testRes: { marginTop: '.6rem', padding: '.5rem .8rem', borderRadius: 8, fontSize: '.78rem' },
  testOk: { background: '#d1fae5', color: '#065f46' },
  testErr: { background: '#fee2e2', color: '#991b1b' },
  btns: { display: 'flex', gap: '.6rem', marginTop: '1.2rem' },
  btnTest:   { flex: .6, padding: '.7rem', borderRadius: 10, fontSize: '.86rem', fontWeight: 600, fontFamily: 'Inter, sans-serif', border: '1.5px solid #1a3a5c', background: '#fff', color: '#1a3a5c', cursor: 'pointer' },
  btnCancel: { flex: 1, padding: '.7rem', borderRadius: 10, fontSize: '.86rem', fontWeight: 600, fontFamily: 'Inter, sans-serif', border: 'none', background: '#f0f0f0', color: '#555', cursor: 'pointer' },
  btnSave:   { flex: 1, padding: '.7rem', borderRadius: 10, fontSize: '.86rem', fontWeight: 600, fontFamily: 'Inter, sans-serif', border: 'none', background: '#1a3a5c', color: '#fff', cursor: 'pointer' },
};
